<span
  role="button"
  tabindex="0"
  [ngClass]="{
    'link-clickable': userAuthService.checkPermission('MANAGE.RELEASE.MODIFY'),
    'link-disabled': !userAuthService.checkPermission('MANAGE.RELEASE.MODIFY')
  }"
  (click)="userAuthService.checkPermission('MANAGE.RELEASE.MODIFY') && onClick()"
  (keydown)="$event.stopPropagation()"
>
  {{ params?.value }}
</span>